import React from 'react';
import { Link } from 'react-router-dom';
import SEO from '../components/SEO';
import styles from './NewHome.module.css';

function NewHome() {
  // Structured data for homepage
  const homeStructuredData = {
    "@context": "https://schema.org",
    "@type": "Organization",
    "name": "Sapienta VC",
    "alternateName": "Sapienta Venture Capital",
    "url": "https://sapienta.vc",
    "logo": "https://sapienta.vc/img/sainet_logo.svg",
    "description": "Sapienta Venture Capital backs ambitious projects with long-term perspective. We offer strategic investment, personalized advisory, and market insights to help startups build their future.",
    "foundingDate": "2020",
    "areaServed": "Global",
    "knowsAbout": ["Venture Capital", "Startup Investment", "Digital Asset Fund", "Business Advisory", "Strategic Investment"],
    "contactPoint": [
      {
        "@type": "ContactPoint",
        "telephone": "",
        "contactType": "customer service",
        "email": "info@sapienta.vc",
        "availableLanguage": "English"
      }
    ],
    "address": {
      "@type": "PostalAddress",
      "addressCountry": "US"
    }
  };

  return (
    <div className={styles.container}>
      <SEO
        title="Sapienta VC - Venture Capital Investment"
        description="Sapienta Venture Capital backs ambitious projects with long-term perspective. Strategic investment, personalized advisory, and market insights."
        keywords="venture capital, startup investment, VC firm, business advisory, digital asset fund"
        url="https://sapienta.vc/"
        structuredData={homeStructuredData}
      />

      <main className={styles.main}>
        <section className={`${styles.section} ${styles.centeredSection}`}>
          <h2>Our Philosophy</h2>
          <div className={styles.philosophyContainer}>
            <div className={styles.contentBlock}>
              <h3>Payment</h3>
              <p>We focus on building ventures that revolutionize financial transactions and payment systems, ensuring seamless, secure, and scalable solutions that drive the future of digital commerce.</p>
            </div>
            <div className={styles.contentBlock}>
              <h3>AI</h3>
              <p>We act with conviction on artificial intelligence and machine learning investments that are transforming industries – backing the intelligent solutions that shape tomorrow's world.</p>
            </div>
            <div className={styles.contentBlock}>
              <h3>Cyber</h3>
              <p>We invest in cybersecurity ventures that protect digital infrastructure, safeguard data, and enable businesses to operate securely in an increasingly connected world.</p>
            </div>
          </div>
        </section>

        <hr className={styles.divider} />

        <section className={styles.section}>
          <h2>Company Information</h2>
          <p className={styles.sectionDescription}>Introduces Sapienta and features our expert research and commentary. The latest Sapienta news, announcements, and more.</p>
          <ul className={styles.linkList}>
            <li><Link to="/company-information">Company Information and Insights</Link></li>
            <li><Link to="/investment-philosophy">Investment Philosophy</Link></li>
          </ul>
        </section>

        <hr className={styles.divider} />

        {/* 8Decimals Digital Assets section - commented out
        <section className={`${styles.section} ${styles.centeredSection}`}>
          <h2 className={styles.digitalAssetsHeading}>
            Digital Assets
          </h2>
          <p className={styles.sectionDescription}>
            Introducing 8Decimals, our cryptocurrency fund focused on digital asset investments.
            We combine traditional investment principles with crypto analytics to capture
            opportunities in the evolving digital asset ecosystem.
          </p>
          <ul className={styles.linkList}>
            <li><a href="https://8decimals.com/" target="_blank" rel="noopener noreferrer">8Decimals - Our Digital Asset Fund</a></li>
          </ul>
        </section>

        <hr className={styles.divider} />
        */}


        <section className={styles.section}>
          <h2>Investment Focus</h2>
          <ul className={styles.linkList}>
            <li><a href="/portfolio">Portfolio Companies</a></li>
            <li><Link to="/investment-criteria">Investment Criteria and Insights</Link></li>
            <li><a href="mailto:contact@sapienta.vc" onClick={(e) => {e.preventDefault(); window.location.href = `mailto:${atob('Y29udGFjdEBzYXBpZW50YS52Yw==')}`;}}>Funding Applications</a></li>
          </ul>
        </section>

        <hr className={styles.divider} />

        <section className={styles.section}>
          <h2>Opportunities</h2>
          <p className={styles.sectionDescription}>Interested in joining us? Learn more about our openings. Learn more about our charitable giving to fulfill your philanthropic goals.</p>
          <ul className={styles.linkList}>
            <li><Link to="/careers">Career Opportunities</Link></li>
            <li><a href="mailto:charity@sapienta.vc" onClick={(e) => {e.preventDefault(); window.location.href = `mailto:${atob('Y2hhcml0eUBzYXBpZW50YS52Yw==')}`;}}>Sapienta Charitable</a></li>
          </ul>
        </section>

        <hr className={styles.divider} />

        <section className={styles.section}>
          <h2>Contact</h2>
          <p className={styles.sectionDescription}>Find the right way to get in touch with us quickly.</p>
          <ul className={styles.linkList}>
            <li><a href="mailto:info@sapienta.vc" onClick={(e) => {e.preventDefault(); window.location.href = `mailto:${atob('aW5mb0BzYXBpZW50YS52Yw==')}`;}}>General Inquiries</a></li>
            <li><a href="mailto:contact@sapienta.vc" onClick={(e) => {e.preventDefault(); window.location.href = `mailto:${atob('Y29udGFjdEBzYXBpZW50YS52Yw==')}`;}}>Contact Us</a></li>
          </ul>
        </section>
      </main>

      <footer className={styles.footer}>
        <h3>Important Information</h3>
        <p>All investments involve risk, including the potential loss of the money you invest.</p>
        <p>Sapienta operates as a group of ventures, owned and driven by its portfolio of businesses and strategic partners. While we provide guidance and strategic support to our ventures, the experiences of one Sapienta partner or venture may not reflect the experiences of others and do not guarantee future performance or success.</p>
        <p>A partner includes any entity or individual engaging with Sapienta through advisory services, business collaboration, or strategic investments. Non-US ventures and independent business entities are not directly owned by Sapienta.</p>
        <p>Advisory services and strategic guidance are provided by Sapienta Advisers, LLC., or affiliated entities within the Sapienta group.</p>
      </footer>
    </div>
  );
}

export default NewHome;